'use client';

import { memo } from 'react';
import { LuWarehouse } from 'react-icons/lu';

import ComingSoonPage from '@features/comingSoon/ComingSoonPage';

const WarehousePage = () => {
  return (
    <ComingSoonPage
      title="Find warehouse"
      description="Locate vetted warehouses for storage and warehouse-receipt collateral near your supply. We're wiring this up next."
      icon={<LuWarehouse size="24px" />}
    />
  );
};

export default memo(WarehousePage);
